import { Box, styled, Tooltip } from "@mui/material";
import { ColumnsPanelTrigger, DataGridPro, DataGridProProps, Toolbar, ToolbarButton } from "@mui/x-data-grid-pro";
import { useContext, useMemo } from "react";

import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { AppContext } from "../../../../../../common/contexts/app_context/app_context";
import { useColumnSelectionConfig } from "../../../../../../common/hooks/use_column_selection_config";

/**
 * CustomToolbar
 */

const CustomToolbar = ({ toolbarRightSlot }: any) => {
  return (
    <Toolbar>
      <Tooltip title="Colunas">
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize="small" />
        </ColumnsPanelTrigger>
      </Tooltip>
    </Toolbar>
  );
};

/**
 * CustomStyledDataGrid
 */

interface Props extends DataGridProProps {
  tableName: string;
  minHeight?: string;
  height?: string;
  maxHeight?: string;
}

export const CustomStyledDataGrid = ({ tableName, minHeight, height, ...props }: Props) => {
  const [columnsVisibilityModel, handleColumnsVisibilityModel] = useColumnSelectionConfig({
    tabela: tableName,
  });

  const mode = useContext(AppContext).theme;
  const StyledDataGrid = useMemo(() => {
    return styled(DataGridPro)(({ theme }) => ({
      "& .MuiDataGrid-columnHeader": {
        backgroundColor: "#aeeece",
      },
      "& .MuiDataGrid-columnSeparator": {
        color: "black",
      },
      "& .MuiDataGrid-footerContainer": {
        display: "none",
      },
      "& .MuiDataGrid-toolbar .MuiIconButton-root": {
        color: mode === "light" ? "black" : "white",
      },
      "& .MuiDataGrid-columnHeaderTitleContainerContent": {
        "& .MuiCheckbox-root": {
          color: "black",
        },
      },
      "& .MuiIconButton-root": {
        color: "black",
      },
      "& .MuiDataGrid-columnHeaderTitle": {
        wordBreak: "normal",
        whiteSpace: "normal",
        lineHeight: 1.5,
        color: "black",
      },
      backgroundColor: mode === "dark" ? "#2C2C2C" : "#FFFFFF",
    }));
  }, [mode]);

  return (
    <Box sx={{ display: "flex", height: height, width: "100%", minHeight: minHeight }}>
      <StyledDataGrid
        showToolbar={true}
        slots={{
          toolbar: CustomToolbar,
        }}
        slotProps={{
          columnsPanel: {
            style: {
              color: mode === "dark" ? "#ffffff" : "#000000",
            },
          },
        }}
        columnVisibilityModel={columnsVisibilityModel}
        disableColumnSorting={true}
        multipleColumnsSortingMode="always"
        onColumnVisibilityModelChange={handleColumnsVisibilityModel}
        {...props}
        disableColumnMenu={false}
        localeText={{
          noRowsLabel: "Não existem itens para mostrar!",

          columnsManagementSearchTitle: "Buscar",
          columnsManagementNoColumns: "Não há colunas",
          columnsManagementShowHideAllText: "Exibir/Esconder",
          columnsManagementReset: "Reiniciar",
          columnsManagementDeleteIconLabel: "Limpar",

          pinToLeft: "Fixar a esquerda",
          pinToRight: "Fixar a direita",
          unpin: "Desfixar",

          columnMenuShowColumns: "Exibir colunas",
          columnMenuManageColumns: "Gerenciar colunas",

          columnMenuHideColumn: "Esconder coluna",
          columnMenuUnsort: "Desordenar",
          columnMenuSortAsc: "Ordenar ASC",
          columnMenuSortDesc: "Ordenar DESC",
        }}
      />
    </Box>
  );
};
